var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import Container from '@anwb/container';
import { BreadcrumbContainer, BreadcrumbLink, BreadcrumbList, BreadcrumbListItem, } from './styles/breadcrumb.styled';
/**
 * The Breadcrumb component is used to render a breadcrumb bar with the correct styling
 */
const Breadcrumb = (_a) => {
    var { history, class: className } = _a, props = __rest(_a, ["history", "class"]);
    const breadcrumbClassNames = classNames('PONCHO-breadcrumb', className);
    return (React.createElement(BreadcrumbContainer, Object.assign({ className: breadcrumbClassNames }, props),
        React.createElement(Container, { withConstrainedWidth: true, withOuterSpacing: "horizontal" },
            React.createElement(BreadcrumbList, null, history.map(({ text, href }) => (React.createElement(BreadcrumbListItem, { key: text },
                React.createElement(BreadcrumbLink, { variant: "breadcrumb-text", className: "PONCHO-breadcrumb__link", href: href }, text))))))));
};
export default Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map